// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__Iks3m","location":"Header_location__pDCRs"};